/**
 * This object represents the catalog options that are available
 */
export enum Catalog {
    unified = 'UNIFIED',
    seg = 'SEG_PROGRAM',
    he = 'HE',
    content = 'CONTENT',
    professional = 'PROFESSIONAL',
    seg_product = 'SEG_PRODUCT',
    products = 'PRODUCTS',
    articles = 'ARTICLES',
    plp = 'PLP',
}
